import { render, staticRenderFns } from "./vamp_calendar.vue?vue&type=template&id=36676e70&scoped=true&"
import script from "./vamp_calendar.vue?vue&type=script&lang=js&"
export * from "./vamp_calendar.vue?vue&type=script&lang=js&"
import style0 from "./vamp_calendar.vue?vue&type=style&index=0&id=36676e70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36676e70",
  null
  
)

export default component.exports